export default __webpack_public_path__ + "static/project-slide-3-1640-765-1a6fcc75457634c0822202438755324a.jpg";